import { vistaListarVentasXMetodo } from "../infrastructure/supabase/ventasVistaMetodo.repository.js";

export async function listarVentasXMetodoUseCase(filtros) {
  return await vistaListarVentasXMetodo(filtros);
}